import { render } from "./RechargeCenter.vue?vue&type=template&id=4dbce4e2&scoped=true"
import script from "./RechargeCenter.vue?vue&type=script&lang=js"
export * from "./RechargeCenter.vue?vue&type=script&lang=js"

import "./RechargeCenter.vue?vue&type=style&index=0&id=4dbce4e2&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbce4e2"]])

export default __exports__